import axios from "axios";
import { getSite } from "./site";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API });

http.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ws_admin_token");
  if (token && cfg.url?.startsWith("/admin")) {
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  // Attach the current site (dental | clinic) to every request so the
  // backend fetches the right settings document + routes emails/redirects.
  cfg.params = { ...(cfg.params || {}), site: getSite() };
  return cfg;
});

export const api = {
  // public
  health: () => http.get("/health").then((r) => r.data),
  locations: (serviceId) => http.get("/locations", { params: { service_id: serviceId } }).then((r) => r.data),
  services: () => http.get("/services").then((r) => r.data),
  categories: () => http.get("/categories").then((r) => r.data),
  slots: ({ practiceId, serviceId, searchStart }) =>
    http
      .get("/slots", {
        params: { practice_id: practiceId, service_id: serviceId, search_start: searchStart },
      })
      .then((r) => r.data),
  createBooking: (payload) => http.post("/bookings", payload).then((r) => r.data),
  saveBookingDraft: (payload) => http.post("/bookings/draft", payload).then((r) => r.data),
  paymentStatus: (sessionId) => http.get(`/payments/status/${sessionId}`).then((r) => r.data),
  paypalCapture: (orderId) => http.post(`/payments/paypal/capture/${orderId}`).then((r) => r.data),
  stripeCreateIntent: (bookingId) => http.post(`/payments/stripe/intent/${bookingId}`).then((r) => r.data),
  stripeFinalizeIntent: (intentId) => http.post(`/payments/stripe/finalize/${intentId}`).then((r) => r.data),
  searchPatients: (phone) => http.get("/patients/search", { params: { phone } }).then((r) => r.data),

  // admin
  adminLogin: (email, password) => http.post("/admin/login", { email, password }).then((r) => r.data),
  adminBookings: () => http.get("/admin/bookings").then((r) => r.data),
  adminPayments: () => http.get("/admin/payments").then((r) => r.data),
  adminStats: () => http.get("/admin/stats").then((r) => r.data),
  adminDebugSlots: (params) => http.get("/admin/debug/slots", { params }).then((r) => r.data),
  adminConfig: () => http.get("/admin/config").then((r) => r.data),
  adminUpdateConfig: (payload) => http.put("/admin/config", payload).then((r) => r.data),
  adminAbandonedBookings: (opts) => http.get("/admin/abandoned-bookings", { params: opts }).then((r) => r.data),
  adminAbandonedEmailsStatus: () => http.get("/admin/abandoned-emails/enabled").then((r) => r.data),
  adminSetAbandonedEmailsEnabled: (enabled) => http.post("/admin/abandoned-emails/enabled", { enabled }).then((r) => r.data),
  adminResendAbandoned: (id) => http.post(`/admin/abandoned-bookings/${id}/resend`).then((r) => r.data),
  adminMarkAbandonedCompleted: (id) => http.post(`/admin/abandoned-bookings/${id}/mark-completed`).then((r) => r.data),
  adminSeedDefaults: () => http.post("/admin/config/seed-defaults").then((r) => r.data),
  adminTestAerona: () => http.post("/admin/aerona/test").then((r) => r.data),
};
